import { Box } from '@mui/material'
import { SimpleShowLayout, useRecordContext } from 'react-admin'

import { CreateHubButton, EditHubButton } from './buttons'
import AdvancedTextField from '../../components/AdvancedTextField'
import HubPickUpAndDropOffHoursField from '../../components/HubPickUpAndDropOffHoursField'
import HubsMapField from '../../components/HubsMapField'
import ShowCardHeader from '../../components/ShowCardHeader'
import UnitField from '../../components/UnitField'
import { PLACE_DETAILS_FIELD_FORMATTED_ADDRESS } from '../../config/addresses'
import { useCommonStyles } from '../../config/theme'
import { useSmallScreen } from '../../utils/theme'
import { ShowReferenceLinks, Title, useShowStyles } from '../common/show'

const HubShowLayout = () => {
  const showClasses = useShowStyles()
  const commonClasses = useCommonStyles()
  const isSmallScreen = useSmallScreen()

  const record = useRecordContext()
  if (!record) return null
  const organisationId = record.organisation_id

  return (
    <>
      <ShowCardHeader
        action={
          <Box sx={commonClasses.toolbar}>
            <EditHubButton id={record.id} />
            <CreateHubButton organisationId={organisationId} />
          </Box>
        }
      />
      <div style={showClasses.row}>
        <div style={{ flex: 1 }}>
          <SimpleShowLayout sx={showClasses.fieldContainer}>
            <AdvancedTextField source="name" />
            <AdvancedTextField
              source={`address.${PLACE_DETAILS_FIELD_FORMATTED_ADDRESS}`}
              label="resources.hubs.fields.address"
            />
            <UnitField source="geofencing" unit="m" />
          </SimpleShowLayout>
          <SimpleShowLayout sx={showClasses.fieldContainer}>
            <HubPickUpAndDropOffHoursField />
          </SimpleShowLayout>
        </div>
        <Box
          width="100%"
          maxWidth={isSmallScreen ? null : 480}
          sx={{ ...commonClasses.borderTop, ...(isSmallScreen ? {} : commonClasses.borderLeft) }}
        >
          <SimpleShowLayout sx={{ '& .RaSimpleShowLayout-row': { margin: 0, width: '100%' }, ...showClasses.map }}>
            <HubsMapField hubs={[record]} label={false} />
          </SimpleShowLayout>
        </Box>
      </div>
      <ShowReferenceLinks filterValues={{ organisation_id: organisationId }} />
    </>
  )
}

export const HubTitle = (props) => <Title>{props.details || props.record.name}</Title>

export default HubShowLayout
